module.exports = __webpack_public_path__ + "img/l3.0785570f.png";